import Autocomplete from "@mui/material/Autocomplete";
import { ReactNode } from "react";
import { InputAdornment, TextField } from "@mui/material";

// type LabelValuePairType = {
//   label: string;
//   value: string;
// };

type SearchSelectDropdownPropsType = {
  options?: any;
  label?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  helperText?: string;
  error?: boolean;
  freeSolo?: boolean;
  searchedValue?: string;
  size?: "small" | "medium";
  fullWidth?: string;
  isUpLabelPresent?: boolean;
  onSearchValueChangeCb?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  style?: Record<string, string>;
  onBlur?: (e: any) => void;
  onSelectSearchValue?: (data: any) => void;
};

const SearchSelectDropdown = ({
  options = [],
  label = "",
  startIcon,
  endIcon,
  freeSolo = false,
  searchedValue = "",
  fullWidth = "300px",
  isUpLabelPresent,
  onSearchValueChangeCb = () => {},
  onSelectSearchValue = () => {},
  size = "medium",
  style = {},
  helperText = "",
  error = false,
  onBlur = (e) => {},
}: SearchSelectDropdownPropsType) => {
  return (
    <Autocomplete
      disablePortal
      freeSolo={freeSolo}
      options={options}
      sx={{ width: fullWidth }}
      // value={searchedValue} // Bind the external value to the Autocomplete
      onChange={(event, newValue) => {
        onSelectSearchValue(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        onSearchValueChangeCb({
          target: { value: newInputValue },
        } as React.ChangeEvent<HTMLInputElement>); // Trigger value change callback
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={isUpLabelPresent ? label : ""}
          onBlur={onBlur}
          value={searchedValue}
          size={size}
          placeholder={label} // This sets the placeholder
          helperText={helperText}
          error={error}
          onChange={onSearchValueChangeCb}
          slotProps={{
            input: {
              ...params.InputProps,
              ...(startIcon
                ? {
                    startAdornment: (
                      <InputAdornment
                        style={{
                          paddingLeft: "10px",
                          marginRight: "0",
                          cursor: "pointer",
                        }}
                        position="start"
                      >
                        {startIcon}
                      </InputAdornment>
                    ),
                  }
                : {}),
              ...(endIcon
                ? {
                    endAdornment: (
                      <InputAdornment position="start">
                        {endIcon}
                      </InputAdornment>
                    ),
                  }
                : {}),
            },
          }}
          sx={style}
        />
      )}
    />
  );
};

export default SearchSelectDropdown;
